if (!customElements.get('tt-sound-demo')) {
  customElements.define('tt-sound-demo', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-demo-open]');
      this.player = this.querySelector('[data-demo-player]');
      this.template = this.querySelector('[data-demo-template]');
      if (!this.dialog?.showModal || !this.trigger || !this.template) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-demo-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.cleanup(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.trigger.hidden = false;
    }
    open() {
      if (this.dialog.open) return;
      window.pauseAllMedia?.();
      this.player.replaceChildren(this.template.content.cloneNode(true));
      this.dialog.showModal();
      document.body.classList.add('tt-demo-open');
      const video = this.player.querySelector('video');
      if (video) {
        video.muted = false;
        const playing = video.play();
        playing?.catch(() => {}); // Native controls remain usable if autoplay is blocked.
      }
    }
    cleanup() {
      this.player?.querySelector('video')?.pause();
      this.player?.replaceChildren(); // Removing external players also stops their sound.
      document.body.classList.remove('tt-demo-open');
      if (this.isConnected) this.trigger?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.cleanup();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
